module.exports = __webpack_public_path__ + "static/media/Trial 1(3)-kan-du-si-ordet-en-gang-til2.e0342276.mp3";